<template>
    <div>
        <h3 :class="titleClass">{{ title }}</h3>
        <loader v-if="loading"/>
        <ul class="todolist">
            <li v-for="item in items">
                <label v-if="showCheckboxes" class="checkbox-image" @click="setItemStatus(item.id, item.Status)">
                    <input type="checkbox" class="image-checkbox" :checked="item.Status === 'done'" />
                    <span class="ico material-icons align-middle checked-image">check_box</span>
                    <span class="ico material-icons align-middle unchecked-image">check_box_outline_blank</span>
                </label>
                {{ item.Name}}
                <button class="textonly remove-link" @click="removeItem(item.id)">delete</button>
            </li>
            <li><button class="textonly" @click="showModal = true">+ {{ title }}</button></li>
        </ul>
        
        
        <modal v-if="showModal" @close="showModal = false" title="Add an item">
            <form @submit.prevent="add">
                <transition name="fade">
                    <alert-bar v-if="msgtext" v-bind:class="msgclass">{{msgtext}}</alert-bar>
                </transition>
                <input-default label="Name" v-model="itemName"/>
                <div class="button-row">
                    <button class="button" type="submit" :disabled="adding">Add</button>
                    <loader v-if="loading"/>
                </div>
            </form>
        </modal>
    </div>
</template>

<script>
    import InputDefault from '../form/InputDefault.vue'
    import Modal from '../modal/Modal.vue'
    import Loader from '../ui/Loader.vue'
    import axios from 'axios'

    export default {
        components: {
            Modal,
            InputDefault,
            Loader
        },
        props: {
            title: {
                default: 'TODO list',
                type: String
            },
            setname: {
                default: 'TODO',
                type: String
            },
            titleClass: {
                default: 'display-6',
                type: String
            },
            showCheckboxes: {
                default: false,
                type: Boolean
            }
        },
        data: function() {
            return{
                msgtext: '',
                msgclass: 'error',
                error: '',
                itemName: '',
                loading: false,
                adding: false,
                showModal: false,
                items: [],
                loading: true,
                token: JSON.parse(localStorage.getItem('user')).id,
                titleTag: 'h3'
            }
        },
        methods: {
            add(){

                this.loading = true;
                this.adding = true;

                const data = {
                    Name: this.itemName,
                    SetName: this.setname,
                    ProjectBlockId: this.$route.params.projectblockid
                }
                axios.post(process.env.VUE_APP_ROOT_API+'/projects/'+this.$route.params.projectid+'/items?access_token='+this.token, data)
                .then(
                    response => {
                        this.get(),
                        this.loading = false
                        this.adding = false
                        this.showModal = false
                        this.itemName = ''
                    },
                    error => {
                        this.msgtext = error,
                        this.loading = false
                        this.adding = false
                    }
                )
            },
            setItemStatus(itemId, itemStatus){

                if(itemStatus != 'done'){
                    itemStatus = 'done'
                } else {
                    itemStatus = 'undone'
                }

                let data = {
                    Status: itemStatus
                }
                axios.put(process.env.VUE_APP_ROOT_API+'/projects/'+this.$route.params.projectid+'/items/'+itemId+'?access_token='+this.token, data)
                .then(
                    response => this.get(),
                    error => {
                        this.msgtext = error,
                        this.loading = false
                    }
                )
            },
            removeItem(itemId){
                axios.delete(process.env.VUE_APP_ROOT_API+'/projects/'+this.$route.params.projectid+'/items/'+itemId+'?access_token='+this.token)
                .then(
                    response => this.get(),
                    error => {
                        this.msgtext = error,
                        this.loading = false
                    }
                )
            },
            get(){

                var filter = {
                    where: {
                        ProjectBlockId: this.$route.params.projectblockid,
                        SetName: this.setname
                    }
                };

                var filters = JSON.stringify(filter);

                axios.get(process.env.VUE_APP_ROOT_API+'/projects/'+this.$route.params.projectid+'/items?filter='+filters+'&access_token='+this.token)
                    .then(response => {
                    this.items = response.data
                    this.loading = false
                })
            }
        },
        mounted(){
            this.get()
        },
        watch: {
            '$route' (to, from) {
                this.get()
            }
        }
    }
</script>

<style lang="scss">
.checkbox-image{
    input{
        display: none;
    }
    .checked-image{
        display: none;
    }
    input:checked ~ .checked-image{
        display: inline-block;
    }
    input:checked ~ .unchecked-image{
        display: none;
    }

    .ico:hover{
        cursor: pointer;
        color: $action;
    }
}

.remove-link{
    display: none;
}

.todolist li:hover {
    .remove-link{
        display: inline;

        &:hover{
            color: $error;
        }
    }
}
</style>
